'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _elementConstants = require('./elementConstants');

var TYPES = _interopRequireWildcard(_elementConstants);

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Attachment Uploads
var uploadingAttachment = function uploadingAttachment(state, action) {
    var stateUpdate = {
        attachment: {
            fetching: true,
            fetched: false
        }
    };
    return state.mergeDeep(stateUpdate);
};
var attachmentDataReady = function attachmentDataReady(state, action) {
    var stateUpdate = {
        attachment: {
            data: action.attachmentData
        }
    };
    return state.mergeDeep(stateUpdate);
};
var updateAttachmentProgress = function updateAttachmentProgress(state, action) {
    return state.setIn(['attachment', 'percentageComplete'], action.percentageComplete);
};

var completeAttachmentUpload = function completeAttachmentUpload(state, action) {
    var stateUpdate = {
        attachment: {
            fetching: false,
            fetched: true
        }
    };
    return state.mergeDeep(stateUpdate);
};

var attachmentError = function attachmentError(state, action) {
    var stateUpdate = {
        attachment: {
            data: null,
            error: action.error,
            fetching: false
        }
    };
    return state.mergeDeep(stateUpdate);
};

var cleanAttachment = function cleanAttachment(state, action) {
    return state.set('attachment', Immutable.Map());
};

exports.default = function (state, action) {
    switch (action.type) {
        case TYPES.ELEMENT_ATTACHMENT_UPLOADING:
            return uploadingAttachment(state, action);
        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_COMPLETED:
            return completeAttachmentUpload(state, action);
        case TYPES.ELEMENT_ATTACHMENT_CLEAN:
            return cleanAttachment(state, action);
        case TYPES.ELEMENT_ATTACHMENT_DATA_READY:
            return attachmentDataReady(state, action);
        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_PROGRESSED:
            return updateAttachmentProgress(state, action);
        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_ERROR:
            return attachmentError(state, action);
        case TYPES.ELEMENT_ATTACHMENT_CLEAR_ERROR:
            return cleanAttachment(state, action);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/common/elements/elementReducerAttachments.js
// module id = 2267
// module chunks = 0